import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { ThemeToggle } from "@/components/theme-toggle";
import { supabase } from "@/integrations/supabase/client";

export function GrantsSiteHeader() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    let mounted = true;
    supabase.auth.getSession().then(({ data }) => {
      if (mounted) setIsLoggedIn(!!data.session);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_e, session) => {
      setIsLoggedIn(!!session);
    });
    return () => {
      mounted = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  const authedLink = isLoggedIn ? (
    <Link
      to="/dashboard"
      search={{ tab: "autofill" }}
      className="text-[15px] font-medium text-muted-ink hover:text-ink"
    >
      Autofill Profile
    </Link>
  ) : (
    <Link
      to="/login"
      className="text-[15px] font-medium text-muted-ink hover:text-ink"
    >
      Log in
    </Link>
  );

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-bg/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1120px] items-center justify-between gap-3 px-5">
        <Link
          to="/"
          className="flex min-w-0 items-center gap-2.5 text-lg font-semibold tracking-tight text-ink"
        >
          <span className="inline-block h-[22px] w-[22px] shrink-0 rounded-md bg-accent" />
          <span className="truncate">DeckScore</span>
        </Link>
        {/* Desktop nav */}
        <div className="hidden items-center gap-5 md:flex">
          <Link
            to="/"
            className="text-[15px] font-medium text-muted-ink hover:text-ink"
          >
            Deck Analysis
          </Link>
          <Link
            to="/grants"
            className="text-[15px] font-medium text-muted-ink hover:text-ink"
            activeProps={{ className: "text-[15px] font-semibold text-ink" }}
          >
            Grants
          </Link>
          <Link
            to="/apply"
            className="text-[15px] font-medium text-muted-ink hover:text-ink"
          >
            Reach Investors
          </Link>
          <Link
            to="/for-investors"
            className="text-[15px] font-medium text-muted-ink hover:text-ink"
          >
            For Investors
          </Link>
          <ThemeToggle />
          {authedLink}
        </div>
        {/* Mobile hamburger */}
        <button
          type="button"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          aria-controls="grants-mobile-menu-panel"
          onClick={() => setMenuOpen((v) => !v)}
          className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-line bg-surface text-ink md:hidden"
        >
          <span className="sr-only">Menu</span>
          {menuOpen ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
          )}
        </button>
      </div>
      {menuOpen && (
        <div
          id="grants-mobile-menu-panel"
          className="border-t border-line bg-bg/95 backdrop-blur-md md:hidden"
        >
          <nav className="mx-auto flex max-w-[1120px] flex-col px-5 py-2">
            <Link to="/" onClick={() => setMenuOpen(false)} className="flex min-h-11 items-center text-[16px] font-medium text-ink">Deck Analysis</Link>
            <Link to="/grants" onClick={() => setMenuOpen(false)} className="flex min-h-11 items-center text-[16px] font-medium text-ink">Grants</Link>
            <Link to="/apply" onClick={() => setMenuOpen(false)} className="flex min-h-11 items-center text-[16px] font-medium text-ink">Reach Investors</Link>
            <Link to="/for-investors" onClick={() => setMenuOpen(false)} className="flex min-h-11 items-center text-[16px] font-medium text-ink">For Investors</Link>
            {isLoggedIn ? (
              <Link
                to="/dashboard"
                search={{ tab: "autofill" }}
                onClick={() => setMenuOpen(false)}
                className="flex min-h-11 items-center text-[16px] font-medium text-ink"
              >
                Autofill Profile
              </Link>
            ) : (
              <Link to="/login" onClick={() => setMenuOpen(false)} className="flex min-h-11 items-center text-[16px] font-medium text-ink">
                Log in
              </Link>
            )}
            <div className="flex min-h-11 items-center justify-between">
              <span className="text-[16px] font-medium text-ink">Theme</span>
              <ThemeToggle />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
